import React from 'react';
import { inputClassName } from '../../utils/assetHelpers';

const DatalistInput = ({
    id,
    label,
    value,
    onChange,
    options = [],
    required = false,
    placeholder = '',
    type = 'text',
}) => (
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        <input
            type={type}
            required={required}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={inputClassName}
            placeholder={placeholder}
            list={options.length > 0 ? id : undefined}
        />
        {options.length > 0 && (
            <datalist id={id}>
                {options.map((option) => (
                    <option key={option} value={option} />
                ))}
            </datalist>
        )}
    </div>
);

export default DatalistInput;
